// @ts-nocheck
import React from 'react';
import InteractiveSlider from '../InteractiveSlider';
import { CarComparisonData } from '../../types/carComparison';

interface GeneralCostsProps {
  data: CarComparisonData;
  onInputChange: (field: keyof CarComparisonData, value: any) => void;
  showGuidance: (title: string, content: string) => void;
  comparisonMode?: boolean;
}

const GeneralCosts: React.FC<GeneralCostsProps> = ({ 
  data, 
  onInputChange, 
  showGuidance, 
  comparisonMode = false 
}) => {
  const renderInputSection = (title: string, children: React.ReactNode) => (
    <div className="input-section">
      <h3>{title}</h3>
      <div className="input-grid">
        {children}
      </div>
    </div>
  );

  return (
    renderInputSection('General Costs', (
      <>

          <InteractiveSlider
            config={{
              min: 0,
              max: comparisonMode ? 5000 : 15000,
              step: comparisonMode ? 100 : 500,
              defaultValue: comparisonMode ? 1200 : 1200,
              format: 'currency',
              label: 'Annual Insurance'
            }}
            value={data.annualInsurance}
            onChange={(value) => onInputChange('annualInsurance', value)}
            guidanceTitle="Annual Insurance"
            guidanceContent={
              "How much do you pay for car insurance each year?<br><br>" +
              '<strong>Factors that affect insurance costs:</strong><br>' +
              '• Your age and driving record<br>' +
              '• Vehicle type and value<br>' +
              '• Coverage level and deductibles<br>' +
              '• Location and parking situation<br>' +
              '• Annual mileage<br><br>' +
              '<strong>Typical annual costs:</strong><br>' +
              '• Basic coverage: $800-1,500<br>' +
              '• Standard coverage: $1,200-2,500<br>' +
              '• Premium coverage: $2,000-4,000+<br><br>' +
              'Shop around and ask about discounts for good driving, bundling, or safety features!'
            }
            onShowGuidance={showGuidance}
          />

        
          <InteractiveSlider
            config={{
              min: 0,
              max: comparisonMode ? 5000 : 10000,
              step: comparisonMode ? 100 : 100,
              defaultValue: comparisonMode ? 500 : 300,
              format: 'currency',
              label: comparisonMode ? 'Other Annual Car Costs' : 'Other Annual Costs'
            }}
            value={data.otherCarCosts}
            onChange={(value) => onInputChange('otherCarCosts', value)}
            guidanceTitle="Other Annual Car Costs"
            guidanceContent={
              "What other costs do you have for your car each year?<br><br>" +
              '<strong>Common additional costs:</strong><br>' +
              '• Parking fees (home/work/public)<br>' +
              '• Car washes and detailing<br>' +
              '• Accessories and modifications<br>' +
              '• Roadside assistance memberships<br>' +
              '• Winter tires and storage<br><br>' +
              '<strong>Don\'t forget:</strong><br>' +
              '• Tolls and bridge fees<br>' +
              '• Traffic tickets and fines<br>' +
              '• Emergency repairs not covered by warranty<br><br>' +
              'These costs can add up quickly, so be realistic!'
            }
            onShowGuidance={showGuidance}
          />
        
        
          <InteractiveSlider
            config={{
              min: 0,
              max: 20,
              step: 0.1,
              defaultValue: 7.0,
              format: 'percent',
              label: 'Investment Return Rate (%)'
            }}
            value={data.investmentReturnRate}
            onChange={(value) => onInputChange('investmentReturnRate', value)}
            guidanceTitle="Investment Return Rate"
            guidanceContent={
              "What return do you expect on your investments?<br><br>" +
              '<strong>Conservative (3-5%):</strong> Bonds, GICs, savings accounts<br>' +
              '<strong>Moderate (6-8%):</strong> Balanced portfolio, index funds<br>' +
              '<strong>Aggressive (8-12%):</strong> Stock-heavy portfolio<br><br>' +
              '<strong>This represents the opportunity cost:</strong><br>' +
              '• Money spent on a car could be invested instead<br>' +
              '• Higher returns = higher opportunity cost<br>' +
              '• Consider your actual investment strategy<br><br>' +
              'Most people use 6-8% as a reasonable long-term average!'
            }
            onShowGuidance={showGuidance}
          />
      </>
    ))
  );
};

export default GeneralCosts;